import React, { useState, useEffect, useRef } from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { useSelector, useDispatch } from "react-redux";
import throttle from "lodash/throttle";

import { MenuItem } from "../../menu-item";
import MenuRight from "../../../atoms/icons/menu-right";

import { OPEN_SEARCHBAR, OPEN_HAMBURGER_MENU, setNewNotification } from "../../../store/actions";
import Logo from "../../../atoms/icons/logo";
import HamburgerMenus from "../hamburger-menus";
import StickyNavbar from "../../../molecules/sticky-navbar";
import HeaderRight from "../header-right";

import "./mobile-header.m.css";
import Modal from "../../../atoms/modal";
import NotificationBox from "../../../molecules/notification-box";
import CokHeader from "../cok-header";

const MobileHeader = ({ isHardcodedHeader, showPrimaryHeader = true, showSecondaryHeader = true , showStickyNavbar=false}) => {
  const dispatch = useDispatch();
  // const notificationsData = useSelector((state) => get(state, ["notificationList"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], "home-page"));

  const getState = useSelector((state) => state);

  const primaryMenus = get(getState, ["qt", "data", "navigationMenu", "primaryMenus"], []);
  const secondaryMenus = get(getState, ["qt", "data", "navigationMenu", "secondaryMenus"], []);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);
  const [showModal, setShowModal] = useState(false);
  const notificationList = get(getState, "notificationList");

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen
    });
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false
    });
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const primaryMenu = document.querySelector(".primary-menu");
      const secondaryMenu = document.querySelector(".secondary-menu");
      function checkScroll() {
        if (window.scrollY > 74) {
          primaryMenu.classList.add("primary-menu-sticky");
          if (pageType === "story-page") {
            const storySection = document.querySelector(".story-section");
            const storySectionTop = storySection?.getBoundingClientRect().top;
            const taboolaAd = document.querySelector("#ad-wrapper-taboola");
            const taboolaAdTop = taboolaAd?.getBoundingClientRect().top;
                    const isInsideStory =
              storySectionTop !== undefined &&
              storySectionTop <= 74 &&
              (taboolaAdTop === undefined || taboolaAdTop > 74);
            if (isInsideStory) {
              primaryMenu.classList.add("hide-primary-menu");
            } else {
              primaryMenu.classList.remove("hide-primary-menu");
            }
          }
        } else {
          primaryMenu.classList.remove("primary-menu-sticky");
          primaryMenu.classList.remove("hide-primary-menu");
          secondaryMenu.style.marginTop = "0px";
        }
      }

      document.addEventListener("scroll", checkScroll);
      return () => {
        document.removeEventListener("scroll", checkScroll);
      };
    }
  }, [pageType]);

  const blackBarRef = useRef(null);
  const [whiteMenuTop, setWhiteMenuTop] = useState(120.4);
  const [finalSecondary, setFinalSecondary] = useState(showSecondaryHeader);

  useEffect(() => {
    if (!blackBarRef.current) return;
    const primaryHeight = showPrimaryHeader ? 74 : 0;
    setWhiteMenuTop(primaryHeight + blackBarRef.current.offsetHeight);
  }, [showPrimaryHeader, showSecondaryHeader, finalSecondary]);

  useEffect(() => {
  const handleScroll = () => {
    const storySection = document.querySelector(".story-section");
    if (!storySection) return;

    if (window.scrollY < 50) {
      setFinalSecondary(true);
      return;
    }

    const storySectionTop = storySection.getBoundingClientRect().top;
    const taboolaAd = document.querySelector("#ad-wrapper-taboola");
    const taboolaAdTop = taboolaAd?.getBoundingClientRect().top;
    const isInsideStory =
      storySectionTop <= 74 &&
      (taboolaAdTop === undefined || taboolaAdTop > 74);

    if (!isInsideStory) {
      setFinalSecondary(true);
      return;
    }

    const isFollowBarSticky = !!document.querySelector(".sticky-div.sticky");
    if (!isFollowBarSticky) {
      setFinalSecondary(true);
      return;
    }

    setFinalSecondary(false);
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  useEffect(() => {
    if (window.innerWidth >= 1025) return;
    const topBarContainer = document.querySelector(".top-bar-container");
    if (!topBarContainer) return;
    const secondaryVisible = showSecondaryHeader && finalSecondary;
    if (showPrimaryHeader && secondaryVisible) {
      topBarContainer.style.minHeight = "151px";
    } else if (showPrimaryHeader) {
      topBarContainer.style.minHeight = "74px";
    } else {
      topBarContainer.style.minHeight = "0px";
    }
    return () => {
      topBarContainer.style.minHeight = "";
    };
  }, [showPrimaryHeader, showSecondaryHeader, finalSecondary]);

  useEffect(() => {
    if (showModal) {
      window.localStorage.setItem("latestNotificationCreatedAt", notificationList[0]?.createdAt);
      dispatch(setNewNotification(false));
    }
  }, [showModal]);

  const getPrimaryMenus = () => {
    return (
      <div styleName="primary-menus">
        {primaryMenus.slice(0, 10).map((item, index) => (
          <div key={index} styleName="primary-menu-item">
            <MenuItem
              changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
              changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
              item={item}
              menuStyle="menu-link"
              toggleHandler={() =>
                dispatch({
                  type: OPEN_SEARCHBAR,
                  isSearchBarOpen: false
                })
              }
            />
          </div>
        ))}
      </div>
    );
  };

  if (isHardcodedHeader == "cok2025") {
    return <CokHeader toggleHandler={toggleHandler} />;
  }

  return (
    <>
      <div styleName="header" id="mob-header">
        <div styleName={`primary ${showPrimaryHeader ? "show" : "hide"}`}>
          <div>
            <Link href="/" styleName="logo">
              <Logo height="56" width="64.63" />
            </Link>
          </div>

          <div styleName="primary-right-wrapper">
            <HeaderRight openNotificationModal={openModal} />
          </div>
        </div>
        {showModal && (
          <Modal onClose={closeModal} isOpen={showModal}>
            <NotificationBox closeBtnHandler={closeModal} />
          </Modal>
        )}{" "}
        <><div ref={blackBarRef} styleName={`secondary ${showSecondaryHeader && finalSecondary ? "show" : "hide"}`} className="primary-menu" style={{top: !showPrimaryHeader ? "0px" : "74px"}}>
          {/* <div>
            <HamburgerMenu
              isMobileHamburger={false}
              onMenuToggle={() => toggleHandler()}
              isMegaMenuOpen={isHamburgerMenuOpen}
            />
          </div>{" "} */}
          <div>{getPrimaryMenus()}</div>
        </div>
        <div styleName={`menu-wrapper secondary-menu-wrapper ${showSecondaryHeader && finalSecondary ? "show" : "hide"}`} style={{top: `${whiteMenuTop}px`}} className="secondary-menu">
          {secondaryMenus.slice(0, 10).map((item, index) => (
            <React.Fragment key={index}>
              <div styleName="secondary-menu-item">
                <MenuRight />
                <MenuItem
                  item={item}
                  key={index}
                  type="secondary"
                  menuStyle="menu-link"
                  changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
                  changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
                />
              </div>
            </React.Fragment>
          ))}
        </div></>
      </div>
      <HamburgerMenus />
      <StickyNavbar showStickyNavbar={showStickyNavbar} onMenuToggle={() => toggleHandler()} />
    </>
  );
};

export default MobileHeader;
